import { StringUtils } from './StringUtils';

/**
 * SearchCallback JSDoc type
 *
 * @callback SearchCallback
 * @param {key} URL parameter key
 * @param {value} URL parameter value
 */

/**
 * Utility functions for operation on Uri objects
 */
export const UriUtils = {

  /**
   * Runs a callback for each search parameter found in the current URL
   *
   * @param {SearchCallback} callback Callback on each search parameter
   */
  forEachSearchParameter (callback) {
    const urlParameters = window.location.search;
    const urlParametersAsList = StringUtils.stringToList(urlParameters, ['&', '?']);
    for (let parameter of urlParametersAsList) {
      const parameterAsList = StringUtils.stringToList(parameter, ['=']);
      // Make sure this is a { key - value } parameter
      if (parameterAsList && parameterAsList.length === 2) {
        const key = parameterAsList[0];
        const value = parameterAsList[1];
        callback(key, value);
      }
    }
  }

};
